module.exports = __webpack_public_path__ + "c17aca2584a06945513faff9eea5d036.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Kartbox/img/pakistan1280.gif
 ** module id = 469
 ** module chunks = 0
 **/